import moment from 'moment';
import { timeDurations } from '@graphistry/viz/src/models/timebar';

const labelColor = '#8B7E7E';

function formatTimestamp(d) {
    return moment.utc(d).format('MMM D YYYY, h:mm:ss a z');
    // return d.toString().split('(')[0];
}

export const XAxisTitle = function ({ x, y, height, width, detailsLevel, timeDomain }) {

    const [ len, unit ] = timeDurations[detailsLevel];

    return <g transform={`translate(${x}, ${y})`} style={{textTransform: "uppercase"}}>
            { width > 200 * 2 ?
                <text x={0} y={height/2}
                    style={{
                        fill: labelColor,
                        fontWeight: 'normal',
                        fontSize: '10px'
                    }}>{
                    `${ formatTimestamp(timeDomain[0]) }`
                }</text>
                : null
            }
            { width > (150 + 200 * 2) ?
                    <text x={width/2 - 110/2} y={height/2}
                    style={{
                        fill: labelColor,
                        fontWeight: 'normal',
                        fontSize: '10px'
                    }}>{
                    `Bar width: ${len} ${unit}`
                    }</text>
                : null
            }
            <text x={width} direction="rtl" y={height/2}
                style={{
                    fill: labelColor,
                    fontWeight: 'normal',
                    fontSize: '10px'
                }}>{
                `${ formatTimestamp(timeDomain[1]) }`
            }</text>
        </g>;
}

